module.exports = __webpack_public_path__ + "static/media/nest.9d02bfb7.png";